import apiClient from './apiClient';

// Read-only access to the ingested CFTC Commitments-of-Traders series, backed
// by GET /v2/markets/cot (serverless-portfolio-tracker). Silver only for now.
// Returns { market, source, count, asOf, latest, series }, where each series
// row is a weekly record: reportDate, openInterest, publishedAt, the legacy
// commercial/spec fields, and from 2006-06-13 the disaggregated groups
// (mm / prodMerc / swap / other / nonRept: *Long, *Short, *Net, and for
// mm / prodMerc / swap *Index, *NetChange, *NetPctOfOI). Both reports are
// futures-only (the DWLF-413 decision).
export const cotAPI = {
  getSeries: async ({ market = 'SILVER', limit, fromDate, toDate } = {}) => {
    const params = new URLSearchParams();
    if (market) { params.append('market', market); }
    if (limit) { params.append('limit', String(limit)); }
    if (fromDate) { params.append('fromDate', fromDate); }
    if (toDate) { params.append('toDate', toDate); }
    const qs = params.toString();
    const response = await apiClient.get(`/markets/cot${qs ? `?${qs}` : ''}`);
    return response.data;
  },
};

export default cotAPI;
